// Helpers de moeda — centraliza símbolo + formatação.
//
// PR3 moeda-por-guia: cada guia tem UMA moeda (Guia.Moeda, exposta em
// ProfileDto). Frontend usa `useAuth().profile?.moeda` no painel, e
// `publicProfile?.moeda` no site público (catálogo via PerfilPublicoDto).
//
// formatMoeda(X, "EUR") com decimals padrão (2) → "€ 1.234,56" — idêntico ao
// `${symbol(moeda)} ${fmtValor(v)}` antigo (regressão zero pra Luciana).
// Dashboard usa decimals: 0 pra manter "€ 1.234" do formatCurrency original.

export const MOEDAS = ["EUR", "BRL", "USD"];

export const MOEDA_SIMBOLO = { EUR: "€", BRL: "R$", USD: "$" };

export function simboloMoeda(moeda) {
  return MOEDA_SIMBOLO[moeda] ?? moeda;
}

export function formatMoeda(valor, moeda, { decimals = 2 } = {}) {
  const num = Number(valor ?? 0).toLocaleString("pt-BR", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  return `${simboloMoeda(moeda)} ${num}`;
}
